export const English = {
    prestudySplitter: {
        labels: {
            activityNumberShort: "Act No.",
            activityNumber: "Activity number",
            startTime: "Start time",
            endTime: "End time",
            addActivity: "Add activity",
            addParticipant: "Add participant",
            duration: "Duration",
            minutes: "minutes",
            minutesShort: "min",
            participantName: "Participant name",
            participant: "Participant",
            calculatePrestudy: "Calculate prestudy distribution",
            participantListEmpty: "No participants added, add participants to the prestudy session to continue...",
            activityListEmpty: "No activities added, add activities to the prestudy session to continue...",
            sessionDuration: "Session duration",
            participants: "Participants",
            activities: "Activities",
        },
        errors: {
            invalidActivityNumber: {
                title: "Invalid activity number",
                description: "Activity number must be greater than 1000",
            },
            invalidDuration: {
                title: "Invalid duration",
                description: "Duration must be between 0 and 180 minutes",
            },
            invalidParticipantName: {
                title: "Invalid participant name",
                description: "Participant name cannot be empty",
            },
            existingParticipant: {
                title: "Participant already exists",
                description: "Participant names must be unique in the prestudy session",
            },
            existingActivity: {
                title: "Activity already exists",
                description: "Activity numbers must be unique in the prestudy session",
            },
            differingTokens: {
                title: "Differing tokens",
                description: "The amount of tokens distributed to the activities and participants do not match, the difference is %difference% token(s)",
                shortDescription: "Distribution differs by %minutes% minutes",
            },
        },
    },
};